// extracted by mini-css-extract-plugin
export default {"tabletOrMobile":"CashManage_tabletOrMobile__AiVVG","pointAddBtn":"CashManage_pointAddBtn__kMHJ9"};